import styled from "@xstyled/styled-components";

import { useJobEditField } from "../../useHandlers";

import { FieldWrapper, InputField } from "@otta/design";
import { pxToRem } from "@otta/design-tokens";

const NarrowField = styled(InputField)`
  max-width: ${pxToRem(400)};
`;

export function OfficeDescription() {
  const [formik, meta] = useJobEditField("officeLocation");

  return (
    <FieldWrapper
      showOptionalTag={false}
      label="Office description"
      advice="More detail about your office locations (e.g. Barbican, London). "
      fieldError={meta.touched ? meta.error : undefined}
    >
      {({ field }) => <NarrowField {...formik} {...field} />}
    </FieldWrapper>
  );
}
